/**
 * Grab the CSRF Token stored in the HTML as a convenience for JavaScript
 * @returns {String|Undefined}
 */
export function csrfToken() {
  let token = document.head.querySelector('meta[name="csrf-token"]');
  if (!token) {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    return;
  }

  return token.content;
}

/**
 * Vue plugin for adding a 'csrfToken' property to all component's options
 */
export const TokenPlugin = {
  install(Vue) {
    Vue.mixin({
      csrfToken: csrfToken(),
    });
  },
};
